import styled from '@emotion/styled';

export const Video = styled.video`
  max-width: 100%;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  padding: 15px;
  border-radius: 12px;
`;
